import React from "react";
import { MenuItem, TextField } from "@mui/material";
import { useField } from "formik";
import { CARGOS_SELECT_CANONICAL, CARGOS_SELECT_ROLES } from "../../config/proyectosRolesCatalog";

interface SelectRolProps {
  name: string;
  onlyProjectRoles?: boolean;
}

export default function SelectRol({ name, onlyProjectRoles = false }: SelectRolProps) {
  const [field, meta, helpers] = useField(name);
  const roles = onlyProjectRoles ? CARGOS_SELECT_CANONICAL : CARGOS_SELECT_ROLES;

  return (
    <TextField
      select
      label="Rol del modulo proyectos"
      fullWidth
      required
      {...field}
      onChange={(e) => helpers.setValue(e.target.value)}
      onBlur={() => helpers.setTouched(true)}
      error={meta.touched && Boolean(meta.error)}
      helperText={
        meta.touched && meta.error
          ? meta.error
          : "Los permisos base se asignan segun el rol. Permisos adicionales: solo administrador."
      }
      margin="normal"
    >
      {roles.map((rol) => (
        <MenuItem key={rol.id} value={rol.nombre}>
          {rol.nombre}
        </MenuItem>
      ))}
    </TextField>
  );
}
